import React from 'react';
import ReactDOM from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppTheme from "./theme/AppTheme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppTheme>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AppTheme>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
